import AdminReducers from '../../admin/store/AdminReducers';
import * as actionTypes from './UserActionTypes';

const initialState: any = {
  admin: AdminReducers,
  exams: [],
  allExams: [],
  questions: [],
  answers: [],
  examRunning: false,
  results: {},
  listening_status: [],
  report: '',
  resultId: '',
  questionType: 'Reading',
  filter: 'all',
  listeningPlayId: '',
  stopAudio: false,
  screen_landscape: false,
  currentQuestion: -1,
};

// eslint-disable-next-line
export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_EXAMS:
      return {
        ...state,
        exams: action.payload,
      };
    case actionTypes.GET_EXAMS_ALL:
      return {
        ...state,
        allExams: action.payload,
      };
    case actionTypes.GET_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };
    case actionTypes.SET_QUESTION_POSITION:
      return {
        ...state,
        currentQuestion: action.payload,
      };
    case actionTypes.SET_QUESTION_TYPE:
      return {
        ...state,
        questionType: action.payload,
      };
    case actionTypes.SET_ANSWERS:
      return {
        ...state,
        answers: action.payload,
      };
    case actionTypes.GET_LISTENING_PLAY_ID:
      return {
        ...state,
        listeningPlayId: action.payload,
      };
    case actionTypes.GET_LISTENING_STATUS:
      return {
        ...state,
        listening_status: [...action.payload],
      };
    case actionTypes.GET_RESULTS:
      return {
        ...state,
        results: action.payload,
      };
    case actionTypes.SET_EXAM_RUNNING:
      return {
        ...state,
        examRunning: action.payload,
      };
    case actionTypes.GET_REPORT_ID:
      return {
        ...state,
        report: action.payload,
      };
    case actionTypes.GET_SCREEN_LANDSCAPE:
      return {
        ...state,
        screen_landscape: action.payload,
      };
    case actionTypes.SET_STOP_AUDIO:
      return {
        ...state,
        stopAudio: action.payload,
      };
    case actionTypes.GET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case actionTypes.GET_RESULT_ID:
      return {
        ...state,
        resultId: action.payload,
      };
    default:
      return state;
  }
};
